var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { useAppDispatch } from 'hooks/reduxHooks';
import moment from 'moment';
import { Box, Collapse, Table, TableContainer, TableBody, TableHead, TableRow, TableCell, TableSortLabel, Link, Paper, Button, IconButton, CircularProgress, Menu, MenuItem, TextareaAutosize, Typography, } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { makeStyles } from 'tss-react/mui';
import { SubHeader } from 'common/SubHeader';
import { DATE_FORMAT, DIALOG_TYPES, ERROR_MESSAGE } from 'globals/global.constants';
import { fetchCallNotes, updateCallNotes } from './SeniorCallLogs.action';
import { seniorCallLogsStyle } from './SeniorCallLogs.style';
import { getCurrentSenior } from 'globals/global.functions';
import clsx from 'clsx';
import { API_LOAD_STATE } from 'globals/enums';
import { PauseProvider, usePauseStatus, } from '../SeniorDashboard/PauseContext';
import { getAuditHistory } from 'common/EditAndDisable/PauseManagement.action';
import { InputFields } from 'common/InputFields';
import TaskTable from 'pages/WCPages/TaskManagement/components/TaskTable.component';
import { createTaskIDService, createTaskService, updateTaskService, } from 'pages/WCPages/TaskManagement/services/taskManagement.service';
import SeniorCallLogsFilter from './SeniorCallLogsFilter.component';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { getActiveTemplates } from 'pages/WCPages/Admin/TemplateManagement/SbarDetails.action';
import { openDialog } from 'store/commonReducer/common.action';
import { setTaskList } from '../TaskManagement/TaskManagement.actions';
var useRowStyles = makeStyles()({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    capitalize: {
        textTransform: 'capitalize',
    },
    arrowButton: {
        backgroundColor: '#32602F',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#244022',
            color: '#fff',
        },
    },
    tableBody: {
        fontSize: 13,
    },
    errorText: {
        color: '#f44336',
        fontSize: 12,
        marginLeft: 8,
    },
    sortLabel: {
        '&.MuiTableSortLabel-root': {
            color: 'inherit',
        },
        '&.MuiTableSortLabel-root:hover': {
            color: '#32602F',
        },
        '&.Mui-active': {
            color: '#32602F',
        },
        '& .MuiTableSortLabel-icon': {
            color: '#32602F !important',
        },
    },
});
// Allows letters, numbers, whitespace (including newlines), and common
// clinical-note punctuation: full stops, commas, apostrophes, hyphens,
// slashes, and colons/semicolons. No other special characters are permitted.
var SPECIAL_CHAR_REGEX = /^[a-zA-Z0-9\s.]*$/;
var SPECIAL_CHAR_MESSAGE = 'Special characters are not allowed';
export var SORTABLE_COLUMNS = [
    { key: 'date', label: 'Date Stamp', field: 'call_time' },
    { key: 'time', label: 'Time Stamp', field: 'call_time' },
    { key: 'careagent_name', label: 'Agent', field: 'careagent_name' },
    { key: 'call_type', label: 'Call Type', field: 'call_type' },
    { key: 'call_direction', label: 'Call Direction', field: 'call_direction' },
];
var SeniorCallLogsInner = function (_a) {
    var data = _a.data, sortBy = _a.sortBy, sortOrder = _a.sortOrder, onSort = _a.onSort, filters = _a.filters, onFiltersChange = _a.onFiltersChange, careAgent = _a.careAgent, careAgentOptions = _a.careAgentOptions, onCareAgentChange = _a.onCareAgentChange, props = __rest(_a, ["data", "sortBy", "sortOrder", "onSort", "filters", "onFiltersChange", "careAgent", "careAgentOptions", "onCareAgentChange"]);
    var classes = seniorCallLogsStyle().classes;
    var rowClasses = useRowStyles().classes;
    var _b = usePauseStatus(), isProfilePaused = _b.isProfilePaused, isDevicePaused = _b.isDevicePaused;
    var handleSort = function (column) {
        onSort === null || onSort === void 0 ? void 0 : onSort(column.key);
    };
    var isLoading = props.isDataLoading === API_LOAD_STATE.PROGRESS;
    return (_jsxs(Box, { className: classes.container, "data-testid": 'senior-call-box', children: [_jsx(SubHeader, __assign({}, props)), _jsx(SeniorCallLogsFilter, { disabled: isLoading, initialValue: filters, onChange: function (value) { return onFiltersChange === null || onFiltersChange === void 0 ? void 0 : onFiltersChange(value); }, careAgent: careAgent, careAgentOptions: careAgentOptions, onCareAgentChange: onCareAgentChange }), _jsx(Box, { children: _jsx(TableContainer, { component: Paper, className: classes.tableContainer, children: _jsxs(Table, { "aria-label": 'collapsible table', sx: { '& .MuiTableCell-root': { borderColor: '#E6E9EF' } }, children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, {}), SORTABLE_COLUMNS.map(function (column) { return (_jsx(TableCell, { align: 'center', className: classes.tableHeader, sortDirection: sortBy === column.key ? sortOrder : false, children: _jsx(TableSortLabel, { className: rowClasses.sortLabel, active: sortBy === column.key, direction: sortBy === column.key ? sortOrder : 'asc', onClick: function () { return handleSort(column); }, "data-testid": "sort-".concat(column.key), children: column.label }) }, column.key)); }), _jsx(TableCell, {})] }) }), _jsx(TableBody, { children: isLoading ? (_jsx(TableRow, { children: _jsx(TableCell, { className: classes.noData, colSpan: 7, align: 'center', style: { padding: '48px 0' }, children: _jsx(CircularProgress, { "data-testid": 'callLogsTableLoader' }) }) })) : (_jsxs(_Fragment, { children: [data.map(function (row, i) { return (_jsx(Row, __assign({ row: row, index: i, isProfilePaused: isProfilePaused, isDevicePaused: isDevicePaused }, props), row.call_id)); }), !data.length && (_jsx(TableRow, { children: _jsx(TableCell, { colSpan: 7, align: 'center', className: clsx([classes.tableBody], [classes.noData]), children: "No Record Found" }) }))] })) })] }) }) })] }));
};
var Row = function (_a) {
    var _b, _c;
    var row = _a.row, isProfilePaused = _a.isProfilePaused, isDevicePaused = _a.isDevicePaused, props = __rest(_a, ["row", "isProfilePaused", "isDevicePaused"]);
    var uniqueCount = useRef(1);
    var dispatch = useAppDispatch();
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var _e = useState({
        senior_id: '',
        account_id: '',
        call_id: '',
    }), callInfo = _e[0], setCallInfo = _e[1];
    var _f = useState(''), callNotes = _f[0], setCallNotes = _f[1];
    var _g = useState({
        situation: '',
        background: '',
        assessment: '',
        recommendation: '',
    }), sbar = _g[0], setSbar = _g[1];
    var _h = useState(true), disableEdit = _h[0], setDisableEdit = _h[1];
    var _j = useState(false), isSaving = _j[0], setIsSaving = _j[1];
    var _k = useState([]), actionItems = _k[0], setActionItems = _k[1];
    var _l = useState([]), unresolvedActionItemIds = _l[0], setUnresolvedActionItemIds = _l[1];
    useEffect(function () {
        setOpen(false);
    }, [props.currentPage]);
    var classes = useRowStyles().classes;
    var isEditable = (_c = (_b = props.latestThreeCallIds) === null || _b === void 0 ? void 0 : _b.has(row.call_id)) !== null && _c !== void 0 ? _c : false;
    var _m = React.useState(false), showValidation = _m[0], setShowValidation = _m[1];
    var _o = React.useState(null), anchorEl = _o[0], setAnchorEl = _o[1];
    var _p = React.useState([]), templates = _p[0], setTemplates = _p[1];
    // True when the given field contains characters outside the allowed set.
    var isSituationInvalid = !!sbar.situation && !SPECIAL_CHAR_REGEX.test(sbar.situation);
    var isBackgroundInvalid = !!sbar.background && !SPECIAL_CHAR_REGEX.test(sbar.background);
    var isAssessmentInvalid = !!sbar.assessment && !SPECIAL_CHAR_REGEX.test(sbar.assessment);
    var isRecommendationInvalid = !!sbar.recommendation && !SPECIAL_CHAR_REGEX.test(sbar.recommendation);
    var isCallNotesInvalid = !!callNotes && !SPECIAL_CHAR_REGEX.test(callNotes);
    var seniorInfo = __assign({}, getCurrentSenior());
    var handleTemplateMenu = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.stopPropagation();
                    setAnchorEl(event.currentTarget);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dispatch(getActiveTemplates({
                            template_category: row.call_type,
                            template_type: 'SBAR',
                            is_active: true,
                        }))];
                case 2:
                    response = _a.sent();
                    setTemplates((response === null || response === void 0 ? void 0 : response.data) || []);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setTemplates([]);
                    console.error('Unable to load SBAR templates:', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleTemplateClose = function () { return setAnchorEl(null); };
    var handleTemplateSelect = function (template) {
        handleTemplateClose();
        dispatch(openDialog({
            type: DIALOG_TYPES.ADMIN_ACTION_DIALOG,
            firstMessage: 'Applying another template will replace the current content.',
            secondMessage: ' Continue?',
            successButtonText: 'Continue',
            cancelButtonText: 'Cancel',
            isFailButton: true,
            onSuccessButton: function () { return __awaiter(void 0, void 0, void 0, function () {
                var response, templateContent_1, getTemplateValue, error_2;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, dispatch(getActiveTemplates({
                                    template_id: template.template_id,
                                    version: template.version,
                                    template_type: template.template_type,
                                    template_category: template.template_category || row.call_type,
                                }))];
                        case 1:
                            response = _b.sent();
                            templateContent_1 = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.template_content;
                            if (!templateContent_1)
                                return [2 /*return*/];
                            getTemplateValue = function (field) { var _a, _b, _c; return (_c = (_b = (_a = templateContent_1[field]) === null || _a === void 0 ? void 0 : _a.S) !== null && _b !== void 0 ? _b : templateContent_1[field]) !== null && _c !== void 0 ? _c : ''; };
                            setSbar({
                                situation: getTemplateValue('situation'),
                                background: getTemplateValue('background'),
                                assessment: getTemplateValue('assessment'),
                                recommendation: getTemplateValue('recommendation'),
                            });
                            setCallNotes(getTemplateValue('call_care_notes'));
                            setShowValidation(false);
                            return [3 /*break*/, 3];
                        case 2:
                            error_2 = _b.sent();
                            console.error('Unable to apply SBAR template:', error_2);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); },
        }));
    };
    var resolveActionItems = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (items) {
            var taskIds, existingTasks, resolvedTasks, response, resolvedIds_1, unresolvedIds, error_3, finalTasks;
            if (items === void 0) { items = []; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (props.readonly) {
                            setActionItems([]);
                            setUnresolvedActionItemIds([]);
                            return [2 /*return*/, []];
                        }
                        if (!Array.isArray(items) || !items.length) {
                            setActionItems([]);
                            setUnresolvedActionItemIds([]);
                            return [2 /*return*/, []];
                        }
                        taskIds = items
                            .filter(function (item) { return typeof item === 'string'; })
                            .map(String);
                        existingTasks = items.filter(function (item) { return typeof item !== 'string' && (item === null || item === void 0 ? void 0 : item.task_id); });
                        resolvedTasks = [];
                        if (!taskIds.length) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, createTaskIDService(taskIds)];
                    case 2:
                        response = _a.sent();
                        resolvedTasks = (response === null || response === void 0 ? void 0 : response.data) || [];
                        resolvedIds_1 = resolvedTasks.map(function (task) {
                            return String(task.task_id);
                        });
                        unresolvedIds = taskIds.filter(function (id) { return !resolvedIds_1.includes(id); });
                        setUnresolvedActionItemIds(unresolvedIds);
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        console.error('Failed to fetch task details:', error_3);
                        setUnresolvedActionItemIds(taskIds);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        setUnresolvedActionItemIds([]);
                        _a.label = 6;
                    case 6:
                        finalTasks = __spreadArray(__spreadArray([], existingTasks, true), resolvedTasks, true);
                        setActionItems(finalTasks);
                        dispatch(setTaskList({
                            data: finalTasks,
                            lastEvaluatedKey: null,
                        }));
                        return [2 /*return*/, finalTasks];
                }
            });
        });
    };
    var getCallNotes = function (account_id, senior_id, call_id, action) {
        if (!open) {
            setOpen(true);
            setCallInfo({ senior_id: senior_id, account_id: account_id, call_id: call_id });
            dispatch(fetchCallNotes(account_id, senior_id, call_id)).then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setCallNotes((res === null || res === void 0 ? void 0 : res.care_call_notes) || '');
                            if (!!props.readonly) return [3 /*break*/, 2];
                            return [4 /*yield*/, resolveActionItems((res === null || res === void 0 ? void 0 : res.action_item) || [])];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            setSbar({
                                situation: (res === null || res === void 0 ? void 0 : res.situation) || '',
                                background: (res === null || res === void 0 ? void 0 : res.background) || '',
                                assessment: (res === null || res === void 0 ? void 0 : res.assessment) || '',
                                recommendation: (res === null || res === void 0 ? void 0 : res.recommendation) || '',
                            });
                            return [2 /*return*/];
                    }
                });
            }); });
        }
        else {
            setDisableEdit(true);
            if (action !== 'edit')
                setOpen(false);
        }
    };
    var onSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var isValid, hasSpecialChars, actionItemIds, response, _a, error_4;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    e.preventDefault();
                    if (props.readonly)
                        return [2 /*return*/];
                    isValid = sbar.situation.trim() &&
                        sbar.background.trim() &&
                        sbar.assessment.trim() &&
                        sbar.recommendation.trim();
                    hasSpecialChars = isSituationInvalid ||
                        isBackgroundInvalid ||
                        isAssessmentInvalid ||
                        isRecommendationInvalid ||
                        isCallNotesInvalid;
                    if (!isValid || hasSpecialChars) {
                        setShowValidation(true);
                        return [2 /*return*/];
                    }
                    if (isProfilePaused || isDevicePaused) {
                        return [2 /*return*/];
                    }
                    setIsSaving(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    return [4 /*yield*/, Promise.all(actionItems.map(function (task) { return __awaiter(void 0, void 0, void 0, function () {
                            var payload, response;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!task.task_id) return [3 /*break*/, 3];
                                        if (!(task.updatedFields && Object.keys(task.updatedFields).length)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, updateTaskService(task.task_id, task.updatedFields)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, task.task_id];
                                    case 3:
                                        payload = __assign(__assign(__assign({ title: task.title, status: task.status, priority: task.priority, assigned_to: task.assigned_to, senior_id: task.senior_id, note_type: task.note_type || row.call_type }, (task.due_date && { due_date: task.due_date })), (task.description && { description: task.description })), (task.role && { role: task.role }));
                                        return [4 /*yield*/, createTaskService(payload)];
                                    case 4:
                                        response = _a.sent();
                                        return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.task_id) || (response === null || response === void 0 ? void 0 : response.id)];
                                }
                            });
                        }); }))];
                case 2:
                    actionItemIds = _b.sent();
                    // Always save task IDs with call notes
                    return [4 /*yield*/, dispatch(updateCallNotes(callInfo, __assign({ callNotes: callNotes, actionItems: __spreadArray(__spreadArray([], actionItemIds.filter(Boolean), true), unresolvedActionItemIds, true) }, sbar)))];
                case 3:
                    // Always save task IDs with call notes
                    _b.sent();
                    return [4 /*yield*/, dispatch(fetchCallNotes(callInfo.account_id, callInfo.senior_id, callInfo.call_id))];
                case 4:
                    response = _b.sent();
                    setCallNotes((response === null || response === void 0 ? void 0 : response.care_call_notes) || '');
                    _a = setActionItems;
                    return [4 /*yield*/, resolveActionItems((response === null || response === void 0 ? void 0 : response.action_item) || [])];
                case 5:
                    _a.apply(void 0, [_b.sent()]);
                    setSbar({
                        situation: (response === null || response === void 0 ? void 0 : response.situation) || '',
                        background: (response === null || response === void 0 ? void 0 : response.background) || '',
                        assessment: (response === null || response === void 0 ? void 0 : response.assessment) || '',
                        recommendation: (response === null || response === void 0 ? void 0 : response.recommendation) || '',
                    });
                    setDisableEdit(true);
                    return [3 /*break*/, 8];
                case 6:
                    error_4 = _b.sent();
                    console.error('Failed to update/create task or update call notes:', error_4);
                    return [3 /*break*/, 8];
                case 7:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var resetForm = function () {
        setCallNotes('');
        setSbar({ situation: '', background: '', assessment: '', recommendation: '' });
        uniqueCount.current = 1;
    };
    var onEditClick = function () {
        if (isProfilePaused || isDevicePaused) {
            return;
        }
        getCallNotes(row.account_id, row.senior_id, row.call_id, 'edit');
        setDisableEdit(false);
        setIsSaving(false);
    };
    var createTaskFromCallEntry = function (taskData) { return __awaiter(void 0, void 0, void 0, function () {
        var newTask;
        return __generator(this, function (_a) {
            newTask = __assign(__assign({}, taskData), { note_type: row.call_type, localId: "".concat(Date.now(), "-").concat(Math.random()) });
            setActionItems(function (previousTasks) {
                var updatedTasks = __spreadArray(__spreadArray([], previousTasks, true), [newTask], false);
                dispatch(setTaskList({
                    data: updatedTasks,
                    lastEvaluatedKey: null,
                }));
                return updatedTasks;
            });
            return [2 /*return*/, newTask];
        });
    }); };
    var handleOpenCreateTaskDialog = function () {
        dispatch(openDialog({
            type: DIALOG_TYPES.CREATE_TASK,
            dialogTitle: 'Create Task',
            data: {
                onCreate: createTaskFromCallEntry,
                taskMember: {
                    seniorId: seniorInfo.seniorID,
                    accountId: seniorInfo.accountID,
                },
                note_type: row.call_type,
            },
        }));
    };
    return (_jsxs(React.Fragment, { children: [_jsxs(TableRow, { className: classes.root, children: [_jsx(TableCell, { children: isEditable && !props.readonly && (_jsx(Link, { component: 'button', variant: 'body2', onClick: function () { return onEditClick(); }, "data-testid": 'callLogEditButton', className: classes.tableBody, color: '#0F85EF', disabled: isProfilePaused || isDevicePaused, sx: isProfilePaused || isDevicePaused
                                ? {
                                    color: '#aaaaaa',
                                    cursor: 'not-allowed',
                                    textDecoration: 'none',
                                    pointerEvents: 'none',
                                }
                                : undefined, children: "Edit" })) }), _jsx(TableCell, { align: 'center', scope: 'row', className: classes.tableBody, children: moment(row.call_time).format(DATE_FORMAT) }), _jsx(TableCell, { align: 'center', className: classes.tableBody, children: moment(row.call_time).format('HH:mm') }), _jsx(TableCell, { align: 'center', className: classes.tableBody, children: row.careagent_name }), _jsx(TableCell, { align: 'center', className: clsx([classes.capitalize], [classes.tableBody]), children: row.call_type }), _jsx(TableCell, { align: 'center', className: clsx([classes.capitalize], [classes.tableBody]), children: row.call_direction }), _jsx(TableCell, { align: 'center', className: classes.tableBody, children: _jsx(IconButton, { "aria-label": 'expand row', className: classes.arrowButton, size: 'small', onClick: function () {
                                getCallNotes(row.account_id, row.senior_id, row.call_id);
                            }, "data-testid": 'expandRowIcon', children: open ? _jsx(KeyboardArrowUpIcon, {}) : _jsx(KeyboardArrowDownIcon, {}) }) })] }), _jsx(TableRow, { children: _jsx(TableCell, { style: { paddingBottom: 0, paddingTop: 0 }, colSpan: 7, children: _jsx(Collapse, { in: open, timeout: 'auto', unmountOnExit: true, children: _jsx(Box, { sx: { m: 1.5, px: 2.5, py: 1, backgroundColor: '#FFFFFF' }, children: _jsxs("form", { onSubmit: onSubmit, children: [_jsxs(Box, { mt: 2, children: [_jsxs(Box, { display: 'flex', alignItems: 'center', children: [_jsx(Typography, { sx: {
                                                            color: '#32602F',
                                                            fontWeight: 600,
                                                        }, children: "SBAR" }), _jsx(Box, { sx: {
                                                            flex: 1,
                                                            ml: 2,
                                                            borderBottom: '1px solid #7DB77E',
                                                        } }), _jsx(Button, { variant: 'contained', sx: {
                                                            backgroundColor: '#32602F',
                                                            fontWeight: 600,
                                                            color: '#FFFFFF',
                                                            textTransform: 'none',
                                                            borderRadius: '8px',
                                                            minWidth: 140,
                                                            height: 40,
                                                            px: 2,
                                                            boxShadow: 'none',
                                                        }, startIcon: _jsx(DescriptionOutlinedIcon, {}), endIcon: _jsx(KeyboardArrowDownIcon, {}), disabled: disableEdit, onClick: handleTemplateMenu, children: "Templates" })] }), _jsx(Menu, { anchorEl: anchorEl, open: Boolean(anchorEl), onClose: handleTemplateClose, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' }, children: templates.length ? (__spreadArray([], templates, true).sort(function (a, b) {
                                                    return (a.template_name || '').localeCompare(b.template_name || '');
                                                })
                                                    .map(function (template) { return (_jsx(MenuItem, { onClick: function () { return handleTemplateSelect(template); }, children: template.template_name }, "".concat(template.template_id, "-").concat(template.version))); })) : (_jsx(MenuItem, { disabled: true, children: "No Templates Found" })) })] }), _jsxs(Box, { display: 'grid', gridTemplateColumns: {
                                            xs: '1fr',
                                            md: 'repeat(4, minmax(0, 1fr))',
                                        }, gap: 1.5, mt: 1, children: [_jsxs(Box, { children: [_jsxs(Typography, { variant: 'caption', children: ["Situation", _jsx("span", { className: classes.errorText, children: "*" })] }), _jsx(InputFields, { isError: (showValidation && !sbar.situation.trim()) || isSituationInvalid, errorText: showValidation && !sbar.situation.trim()
                                                            ? ERROR_MESSAGE.REQUIRED_FIELD
                                                            : isSituationInvalid
                                                                ? SPECIAL_CHAR_MESSAGE
                                                                : '', eventProps: {
                                                            value: sbar.situation,
                                                            onChange: function (e) {
                                                                return setSbar(function (prev) { return (__assign(__assign({}, prev), { situation: e.target.value })); });
                                                            },
                                                        }, inputProps: {
                                                            name: 'situation',
                                                            placeholder: 'Enter Situation',
                                                            maxLength: 2000,
                                                            style: { padding: 0 },
                                                        }, disabled: disableEdit, multiline: true, rows: 3 })] }), _jsxs(Box, { children: [_jsxs(Typography, { variant: 'caption', children: ["Background", _jsx("span", { className: classes.errorText, children: "*" })] }), _jsx(InputFields, { isError: (showValidation && !sbar.background.trim()) || isBackgroundInvalid, errorText: showValidation && !sbar.background.trim()
                                                            ? ERROR_MESSAGE.REQUIRED_FIELD
                                                            : isBackgroundInvalid
                                                                ? SPECIAL_CHAR_MESSAGE
                                                                : '', eventProps: {
                                                            value: sbar.background,
                                                            onChange: function (e) {
                                                                return setSbar(function (prev) { return (__assign(__assign({}, prev), { background: e.target.value })); });
                                                            },
                                                        }, inputProps: {
                                                            name: 'background',
                                                            placeholder: 'Enter Background',
                                                            maxLength: 2000,
                                                            style: { padding: 0 },
                                                        }, disabled: disableEdit, multiline: true, rows: 3 })] }), _jsxs(Box, { children: [_jsxs(Typography, { variant: 'caption', children: ["Assessment", _jsx("span", { className: classes.errorText, children: "*" })] }), _jsx(InputFields, { isError: (showValidation && !sbar.assessment.trim()) || isAssessmentInvalid, errorText: showValidation && !sbar.assessment.trim()
                                                            ? ERROR_MESSAGE.REQUIRED_FIELD
                                                            : isAssessmentInvalid
                                                                ? SPECIAL_CHAR_MESSAGE
                                                                : '', eventProps: {
                                                            value: sbar.assessment,
                                                            onChange: function (e) {
                                                                return setSbar(function (prev) { return (__assign(__assign({}, prev), { assessment: e.target.value })); });
                                                            },
                                                        }, inputProps: {
                                                            name: 'assessment',
                                                            placeholder: 'Enter Assessment',
                                                            maxLength: 2000,
                                                            style: { padding: 0 },
                                                        }, disabled: disableEdit, multiline: true, rows: 3 })] }), _jsxs(Box, { children: [_jsxs(Typography, { variant: 'caption', children: ["Recommendation", _jsx("span", { className: classes.errorText, children: "*" })] }), _jsx(InputFields, { isError: (showValidation && !sbar.recommendation.trim()) || isRecommendationInvalid, errorText: showValidation && !sbar.recommendation.trim()
                                                            ? ERROR_MESSAGE.REQUIRED_FIELD
                                                            : isRecommendationInvalid
                                                                ? SPECIAL_CHAR_MESSAGE
                                                                : '', eventProps: {
                                                            value: sbar.recommendation,
                                                            onChange: function (e) {
                                                                return setSbar(function (prev) { return (__assign(__assign({}, prev), { recommendation: e.target.value })); });
                                                            },
                                                        }, inputProps: {
                                                            name: 'recommendation',
                                                            placeholder: 'Enter Recommendation',
                                                            maxLength: 2000,
                                                            style: { padding: 0 },
                                                        }, disabled: disableEdit, multiline: true, rows: 3 })] })] }), _jsxs(Box, { mt: 2, children: [_jsx(Typography, { sx: {
                                                    color: '#32602F',
                                                    fontSize: 13,
                                                    fontWeight: 700,
                                                    borderBottom: '1px solid #32602F',
                                                    pb: 0.5,
                                                }, children: "Care Notes" }), _jsx(TextareaAutosize, { value: callNotes, disabled: disableEdit, onChange: function (e) { return setCallNotes(e.target.value); }, minRows: 3, style: {
                                                    width: '100%',
                                                    boxSizing: 'border-box',
                                                    marginTop: 8,
                                                    padding: 10,
                                                    border: "1px solid ".concat(isCallNotesInvalid ? '#f44336' : '#E1E5EC'),
                                                    borderRadius: 4,
                                                    fontFamily: 'inherit',
                                                    fontSize: 12,
                                                    resize: disableEdit ? 'none' : 'vertical',
                                                } }), isCallNotesInvalid && (_jsx(Typography, { className: classes.errorText, sx: { ml: '0 !important', display: 'block', mt: 0.5 }, children: SPECIAL_CHAR_MESSAGE }))] }), !props.readonly && _jsxs(Box, { mt: 2, children: [_jsxs(Box, { display: 'flex', alignItems: 'center', width: '100%', mb: 1, children: [_jsx(Typography, { sx: {
                                                            color: '#32602F',
                                                            fontSize: 13,
                                                            fontWeight: 700,
                                                            whiteSpace: 'nowrap',
                                                        }, children: "Tasks (Action Items)" }), _jsx(Box, { sx: {
                                                            flex: 1,
                                                            borderBottom: '1px solid #7DB77E',
                                                            ml: 2,
                                                            mr: 2,
                                                        } }), _jsx(Button, { disabled: disableEdit, variant: 'contained', onClick: handleOpenCreateTaskDialog, children: "+ Add Task" })] }), _jsx(TaskTable, { data: actionItems, onTaskUpdate: function (updatedTask) {
                                                    setActionItems(function (previousTasks) {
                                                        return previousTasks.map(function (task) {
                                                            var isSameTask = (task.task_id && task.task_id === updatedTask.task_id) ||
                                                                (task.localId && task.localId === updatedTask.localId);
                                                            return isSameTask ? __assign(__assign({}, task), updatedTask) : task;
                                                        });
                                                    });
                                                }, onTaskDelete: function (task) {
                                                    setActionItems(function (previousTasks) {
                                                        return previousTasks === null || previousTasks === void 0 ? void 0 : previousTasks.filter(function (item) {
                                                            return item.localId !== task.localId;
                                                        });
                                                    });
                                                }, disableEdit: disableEdit })] }), !disableEdit && (_jsxs(Box, { mt: 2, children: [_jsx(Button, { style: {
                                                    marginRight: 4,
                                                    backgroundColor: isSaving ? '#cccccc' : '#32602F',
                                                    color: isSaving ? '#666666' : '#ffffff',
                                                }, variant: 'contained', disabled: isSaving, color: 'primary', type: 'submit', children: "Save" }), _jsx(Button, { variant: 'contained', color: 'primary', style: { backgroundColor: '#32602F' }, onClick: resetForm, children: "Reset" })] }))] }) }) }) }) })] }));
};
var SeniorCallLogsComponent = function (props) {
    var dispatch = useAppDispatch();
    var _a = getCurrentSenior(), seniorID = _a.seniorID, accountID = _a.accountID;
    var _b = useState(null), auditInfo = _b[0], setAuditInfo = _b[1];
    useEffect(function () {
        var run = function () { return __awaiter(void 0, void 0, void 0, function () {
            var info;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch(getAuditHistory())];
                    case 1:
                        info = _a.sent();
                        setAuditInfo(info);
                        return [2 /*return*/];
                }
            });
        }); };
        run();
    }, [dispatch, seniorID, accountID]);
    return (_jsx(PauseProvider, { auditInfo: auditInfo, children: _jsx(SeniorCallLogsInner, __assign({}, props)) }));
};
export default SeniorCallLogsComponent;
